const shared = {};

shared.mobileBreakPoint = '1024px';
shared.sizesMobile = '(sm: 1024) !default';
shared.sizesDesktop = '(md: 1280, lg: 1600px) !default';

//** Number of max columns in the grid
shared.gridMaxColumns = '12 !default';
shared.gridGutterWidth = '32px !default'; // left + right

shared.dateLocales = {
  pt: {
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    monthsShort: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    weekdays: [
      'Domingo',
      'Segunda-Feira',
      'Terça-Feira',
      'Quarta-Feira',
      'Quinta-Feira',
      'Sexta-Feira',
      'Sábado',
    ],
    weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    weekdaysLetter: [],
  },
};

export default shared;
